import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-forest">
      <div className="mx-auto grid max-w-6xl gap-10 px-6 py-12 md:grid-cols-3">
        <div>
          <div className="text-lg font-semibold tracking-[0.16em] text-white uppercase">
            Cedar & Comb
          </div>
          <p className="mt-3 max-w-sm text-sm leading-6 text-stone-400">
            Olympia-area beekeeping services focused on queen rearing, nucs,
            managed colony placement, and swarm catching throughout the South
            Sound.
          </p>
        </div>

        <div>
          <div className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-300">
            Services
          </div>
          <ul className="mt-3 space-y-2 text-sm text-stone-400">
            <li>Queen rearing</li>
            <li>Nucs</li>
            <li>Property hive placement</li>
            <li>Swarm catching & control</li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold uppercase tracking-[0.2em] text-stone-300">
            Explore
          </div>
          <div className="mt-3 flex flex-col gap-2 text-sm">
            <Link
              to="/"
              className="text-stone-400 transition hover:text-amber-300"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-stone-400 transition hover:text-amber-300"
            >
              About
            </Link>
            <Link
              to="/services"
              className="text-stone-400 transition hover:text-amber-300"
            >
              Services
            </Link>
            <Link
              to="/contact"
              className="text-stone-400 transition hover:text-amber-300"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 px-6 py-4 text-center text-xs tracking-wide text-stone-500">
        © {new Date().getFullYear()} Cedar & Comb · Olympia, Washington
      </div>
    </footer>
  );
}
